import Vue from 'vue'
import { domain } from 'src/app_config'
import { smee } from 'src/app-config'

const { mstVendorConnectFolderId } = smee.sharepoint.mstVendorConnectFolderId

export const url = api => domain + api
// export const url = api => 'http://dghk1gisap001:8120' + api

export const getTeamMembers = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/usermanagement/fetchUserList'), {
      params: {
        accessGroupIds: '23'
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: response.body.error || 'Failed'
      })
    })
  })
}

export const getVendors = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/usermanagement/fetchUserList'), {
      params: {
        accessGroupIds: '24'
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: response.body.error || 'Failed'
      })
    })
  })
}

export const getTeamLeader = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/usermanagement/fetchUserList'), {
      params: {
        accessGroupIds: '22' // 17 // 22
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: response.body.error || 'Failed'
      })
    })
  })
}

export const getSharepointFolderId = params => {
  return new Promise((resolve, reject) => {
    resolve({
      folderId: mstVendorConnectFolderId
    })
  })
}

export const getRedmineRoleId = params => {
  let { token, accessGroupId } = params
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/redmine/redmine-role-id'), {
      headers: {
        'Authorization': 'Bearer ' + token
      },
      params: {
        'access-group-id': accessGroupId
      }
    }).then(response => {
      resolve(response.body.redmineRoleId)
    }).catch(response => {
      reject()
    })
  })
}

export const getWorkflow = params => {
  let { trackerId, roleId, token } = params
  if (!trackerId) {
    trackerId = 1
  }
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/redmine/workflow'), {
      headers: {
        'Authorization': 'Bearer ' + token
      },
      params: {
        'tracker-id': trackerId,
        'role-id': roleId
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject()
    })
  })
}

export const getWorkflowPermission = params => {
  let { trackerId, roleId, token } = params
  if (!trackerId) {
    trackerId = 1
  }
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/redmine/workflow-permission'), {
      headers: {
        'Authorization': 'Bearer ' + token
      },
      params: {
        'tracker-id': trackerId,
        'role-id': roleId
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject()
    })
  })
}

export const getIssueCounts = params => {
  let { token, projectId, trackerId, statusIds, assignTo } = params
  let requestParams = {
    'status-ids': statusIds.join(','),
    'project-id': projectId,
    'tracker-id': trackerId
  }
  if (assignTo) {
    requestParams['assign-to'] = assignTo
  }
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/redmine/issue-counts'), {
      headers: {
        'Authorization': 'Bearer ' + token
      },
      params: requestParams
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject()
    })
  })
}

export const getVendorHierarchy = ({ token, vendorProfileIds }) => {
  return Vue.http.get(url('/common/vendorHierarchy'), {
    headers: {
      'Authorization': 'Bearer ' + token
    },
    params: {
      vendorProfileIds: vendorProfileIds.join(',')
    }
  }).then(response => {
    return response.body
  })
}

export const verifyPO = (poList, vendorList, token) => {
  return Vue.http.get(url('/common/validatedPoList'), {
    headers: {
      'Authorization': 'Bearer ' + token
    },
    params: {
      poList: poList.join(','),
      vendorCodeList: vendorList.join(',')
    }
  })
}

export const uploadAttachmentUrl = url('/sharepoint/files')
export const downloadAttachmentBaseUrl = url('/sharepoint/files/download/')



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/service.js